import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../pipe/safe-html.pipe';
import { SharedService } from '../common/shared.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TopnavService } from '../header/topnav/topnav.service';

/**
 * Author: Mohd Azrul Hadi Abd Aziz
 * 
 * Date Created: December 24th 2019
 * 
 * Description: Component class to display different source of feedback - /feedback, feedback/:id
 **/
@Component({
    selector: 'feedback-list',
    templateUrl: './feedbacklist.component.html',
    styleUrls: ['./feedbacklist.component.css'],
    providers: [ SafeHtmlPipe ],
    //encapsulation: ViewEncapsulation.None
  })

export class FeedbackListComponent implements OnInit, AfterViewInit, OnDestroy {
  loading: boolean;
  lang;
  langId;
  
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;
  private subscriptionFontType: ISubscription;
  private subscriptionData: ISubscription;
  private subscriptionTitle: ISubscription;
  public fbdetailsHTML: any;
  public currFbDetailsHTML: any;
  public showMain: boolean = true;
  public feedbackTitle: string;
  public pageList: any;
  public pageContent: any;
  private currCode: number;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  public fontType: string = 'Arial'; 
 
  public myflag: any;
  constructor(private topnavservice: TopnavService, private activatedRoute: ActivatedRoute, private router: Router, private domSanitizer: DomSanitizer, private translate: TranslateService, private sharedService: SharedService) {
    /*this.router.routeReuseStrategy.shouldReuseRoute = ()=> {
        return false;
      };*/
       
        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
            const myLang = translate.currentLang;
    
            if (myLang == 'en') {
    
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'en';
                    this.langId = 1;
                });
            }
            if (myLang == 'ms') {
    
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'ms';
                    this.langId = 2;
                });
    
            }

            if(this.topnavservice.flagLang){
                // recall data to change language
              
                this.pageContent = this.filterByLang(this.pageList);
                if (this.currCode) {
                    this.showDetails();
                }
               
               
            }

            setTimeout(()=>{
                if (this.subscriptionTitle) {
                    this.subscriptionTitle.unsubscribe();
                }
                this.subscriptionTitle = this.translate.get('pageTitle.home').subscribe((title:string) => {
                  title = title + this.translate.instant('home.breadcrumb.feedback');
                  this.sharedService.setTitle(title);
                }); 
            }, 500);

    });

    this.activatedRoute.queryParams.subscribe(params => {
        let lng = params['language'];
        if (lng && lng.toLowerCase() == 'my') {
          this.myflag = {language:"my"};
          this.translate.setDefaultLang('ms');
          this.translate.use('ms');
        } else {
          this.myflag = null;
        } 
      });

      this.activatedRoute.params.subscribe(paramsId => {
          this.currCode = paramsId.id;
          if (this.currCode) {
            this.showDetails();
          } 
         
          console.log('paramsId:', paramsId.id);
    });


    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      
        this.fontSize = data;
        $('.font-size-l').css('font-size', this.fontSize.sizeL);
        $('.font-size-m').css('font-size', this.fontSize.sizeM);
        $('.font-size-s').css('font-size', this.fontSize.sizeS);
        $('.font-size-s li').css('font-size', this.fontSize.sizeS);

        this.resizeContent();    
    });
    
    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
        this.fontType = data;
    });

  
  }

  ngOnInit(){
    if(!this.langId){
        if (localStorage.getItem('langID')) {
          this.langId = localStorage.getItem('langID');
        } else {
          this.langId = 1;
        }  
      }else{
        this.langId = 1;
      }
      this.getPageContent();
    
  }

  ngAfterViewInit() {
       
        //this.showMain = true;
        // Get Title and Sent to GA
        /*if (this.subscriptionTitle) {
            this.subscriptionTitle.unsubscribe();
        }*/
    	this.subscriptionTitle = this.translate.get('pageTitle.home').subscribe((title:string) => {
            title = title + this.translate.instant('home.breadcrumb.feedback');
            this.sharedService.setTitleAndGtag(title);
        }); 
    
        this.sharedService.loadFontSizeData();
        this.sharedService.loadFontTypeData();
  }

  ngOnDestroy()
  {
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
    //this.subscriptionTitle.unsubscribe();
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  getThemeName() {
    return localStorage.getItem('themeName');
  }

  transform(html) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

  itemClick(code) {
    this.currCode = code;   
    if (code !== 0) {
        this.router.navigate(['/feedback/'+code], { queryParams: this.myflag });
    } else {
        this.router.navigate(['/feedbackform'], { queryParams: this.myflag });
    } 
  }

  showDetails() {
    if (!this.pageContent) {
        console.log('pageContent is null');
        return;
    } 
    let record = this.pageContent.find(list=>list.feedbackPageMainUrlCode==this.currCode);
    if (!record) {
        console.log('record is null');
        return;
    }
    
    this.feedbackTitle = record.feedbackPageMainTitle;
    this.fbdetailsHTML = record.feedbackContentPageHtml;
    this.currFbDetailsHTML = record.feedbackContentPageHtml;
    this.resizeContent();
    this.showMain = false;
    
    if (this.subscriptionTitle) {
        this.subscriptionTitle.unsubscribe();
    }
    this.translate.get('pageTitle.home').subscribe((title:string) => {
        title = title + this.feedbackTitle;
        this.sharedService.setTitleAndGtag(title);
    }); 
  }

  backToMainFb() {
      this.currCode = null;
      this.showMain = true;
      this.fbdetailsHTML = null;
      this.feedbackTitle = null;
      this.router.navigate(['/feedback'], { queryParams: this.myflag });

      /*if (this.subscriptionTitle) {
        this.subscriptionTitle.unsubscribe();
      }
      this.subscriptionTitle = this.translate.get('pageTitle.home').subscribe((title:string) => {
        title = title + this.translate.instant('home.breadcrumb.feedback');
        this.sharedService.setTitle(title);
      });*/ 
  }

  resizeContent() {
    let currContent = this.fbdetailsHTML;
    if (this.fbdetailsHTML) {
        this.currFbDetailsHTML = currContent.replace(new RegExp('font-size: 14px', 'g'), 'font-size: ' +                                   this.fontSize.sizeS).replace(new RegExp('font-size: 19px', 'g'), 'font-size: ' + this.fontSize.sizeM);
    }
  }
  getPageContent() {
    if (this.subscriptionData) {
        this.subscriptionData.unsubscribe();
    }

    this.subscriptionData = this.sharedService.getFeedbackMain().subscribe((fbContent)=>{
      this.pageList = fbContent.feedbackPageList;
      this.pageContent = this.filterByLang(this.pageList);
      if (this.currCode) {
          this.showDetails();
      }
    });
 }

 filterByLang(pageList) {
    if (!pageList) return [];

    return pageList.filter((el)=> { 
        return el.language.languageId == this.langId;
    });
 }
  
}


// WEBPACK FOOTER //
// ./src/app/feedback/feedbacklist.component.ts